import { render, staticRenderFns } from "./limitedAvailabilityMessage.vue?vue&type=template&id=282194bb&scoped=true&"
import script from "./limitedAvailabilityMessage.vue?vue&type=script&lang=js&"
export * from "./limitedAvailabilityMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282194bb",
  null
  
)

export default component.exports